import { Menu } from "lucide-react";
import { useSnak } from "../snak/SnakContext";
export function TopBar() {
  const {
    openRefs,
    openChapters
  } = useSnak();
  return <header className="mx-auto flex w-full max-w-xl shrink-0 items-center justify-between gap-3 px-6 pb-2 pt-4" data-id="element-252" data-mp="2ux10dzm1n71c">
      <span className="text-[12px] font-semibold tracking-[0.22em]" data-id="element-253" data-mp="38smng18pvgr4">
        POTELIGEO<sup className="text-[7px]" data-id="element-254" data-mp="34s2r2zvywh61">®</sup>
      </span>
      <div className="flex items-center gap-1" data-id="element-255" data-mp="3isluftphmz1v">
        <button onClick={() => openRefs("compliance")} className="whitespace-nowrap rounded-full bg-amber-soft px-2.5 py-1 text-[10.5px] font-semibold tracking-[0.06em] text-amber" data-id="element-256" data-mp="3iravq8awghhm">
          CONCEPT PROTOTYPE
        </button>
        <button onClick={openChapters} aria-label="Open chapter menu" className="-mr-2 flex h-9 w-9 items-center justify-center rounded-full text-[var(--s-fg)] opacity-80 transition-opacity duration-150 hover:opacity-100" data-id="element-257" data-mp="3njlrr02irj4w">
          <Menu className="h-[18px] w-[18px]" strokeWidth={1.75} data-id="element-258" data-mp="dbc58j0ztu4" />
        </button>
      </div>
    </header>;
}